module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/calendar/calendar.component.html
// module id = ./src/app/calendar/calendar.component.html
// module chunks = main